import { MY_API } from '~/lib/constants';

export function getApiPath(profile: string, path: string): string {
  // return `https://localhost:5001/${profile}${path}`;
  return `${MY_API}/${profile}${path}`;
}
